import React from 'react';
import { useProjectBillableEntries } from '../../hooks';
import { DialogContent } from '@/components/Dialog/DialogContent';

interface ProjectBillableEntriesContextValue {
  projectId: any;
  billableEntries: any;
}

const ProjectBillableEntriesContext =
  React.createContext<ProjectBillableEntriesContextValue>(
    {} as ProjectBillableEntriesContextValue,
  );

interface ProjectBillableEntriesProviderProps {
  projectId?: any;
  [key: string]: any;
}

/**
 * Project billable entries provider.
 * @returns
 */
function ProjectBillableEntriesProvider({
  projectId,
  ...props
}: ProjectBillableEntriesProviderProps) {
  // Handle fetch project billable entries.
  const { data: billableEntries, isLoading: isProjectBillableEntriesLoading } =
    useProjectBillableEntries(projectId, {
      enabled: !!projectId,
    });

  //state provider.
  const provider = {
    projectId,
    billableEntries,
  };

  return (
    <DialogContent isLoading={isProjectBillableEntriesLoading}>
      <ProjectBillableEntriesContext.Provider value={provider} {...props} />
    </DialogContent>
  );
}

const useProjectBillableEntriesContext = () =>
  React.useContext(ProjectBillableEntriesContext);

export { ProjectBillableEntriesProvider, useProjectBillableEntriesContext };
